<div mat-dialog-title>
  <h2 class="text__md fw__600">{{ title }}</h2>
</div>

<div mat-dialog-content>
  <form [formGroup]="variableForm.form" class="source-variable__layout">
    <eiq-input [label]="'Name'" [holdRequiredPlaceholder]="'fixed'" [testId]="'source-variable-dialog-name'" formControlName="variableToken"></eiq-input>

    <eiq-select [label]="'Required'" [options]="requiredTypes" [testId]="'source-variable-dialog-required'" formControlName="variableRequiredType"></eiq-select>

    <eiq-select [label]="'Type'" [options]="valueTypes" [testId]="'source-variable-dialog-type'" formControlName="type"></eiq-select>

    @if (variableForm.form.controls.type.value === listType) {
      <div class="editor-question-form__input source-variable__layout__values">
        <span class="label text__md">Values</span>
        <mat-form-field class="eiq-survey-textarea" appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-chip-grid #chipGrid aria-label="Variable values">
            @for (option of variableForm.options.controls; track option.value.id) {
              <mat-chip-row color="primary" (removed)="onRemoveValue($index)">
                {{ option.value.value }}
                <button
                  matChipRemove
                  [attr.aria-label]="'remove ' + option.value.value"
                  [attr.data-testid]="'source-variable-dialog-value-' + $index + '-remove-button'"
                >
                  <fa-icon [icon]="faClose"></fa-icon>
                </button>
              </mat-chip-row>
            }
          </mat-chip-grid>
          <input
            placeholder="Type values..."
            data-testid="source-variable-dialog-value-input"
            [formControl]="addValueCtrl"
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="onAddValue($event)"
          />
        </mat-form-field>
      </div>
    }
  </form>
</div>

<div mat-dialog-actions>
  <eiq-button [text]="'Cancel'" [style]="'stroked'" [color]="'light'" [testId]="'source-variable-dialog-cancel'" (clicked)="onCancel()"></eiq-button>
  <eiq-button
    [text]="'Save'"
    [color]="'primary'"
    [disabled]="variableForm.form.invalid"
    [testId]="'source-variable-dialog-save'"
    (clicked)="onSave()"
  ></eiq-button>
</div>
